import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <>
      </>
      // <footer className="main-footer">
      //   <strong className="mr-1">
      //     Copyright © 2025 <a href="https://www.3ewebapps.co.in/">3Ewebapps</a>.
      //   </strong >
      //   All rights reserved.
      //   <div div className="float-right d-none d-sm-inline-block" >
      //     <b>Version</b> 1.0.0
      //   </div>
      // </footer >
    );
  }
}
